import React from 'react';
import { useTranslation } from 'react-i18next';
import { TRUSTED_COMPANIES } from '../../constants/data';

export const TrustBadgesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-slate-900 py-12 border-y border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-slate-400 text-sm font-semibold uppercase tracking-widest mb-8">
          {t('trust_badges.title')}
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center opacity-70 grayscale hover:grayscale-0 transition-all duration-500">
          {TRUSTED_COMPANIES.map((company) => (
            <h3
              key={company}
              className="text-2xl font-bold text-white tracking-tight"
            >
              {company}
            </h3>
          ))}
        </div>
      </div>
    </section>
  );
};
